export { Chip } from './Chip';
export type { Props } from './Chip.types';
